"use strict";

var _createClass = require("/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/createClass");
var _classCallCheck = require("/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/classCallCheck");
var _inherits = require("/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/inherits");
var _createSuper = require("/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/createSuper");
Object.defineProperty(exports, "__esModule", {
  value: true
});
var abstractmessage_1 = require("./abstractmessage");
var Init = /*#__PURE__*/function (_abstractmessage_1$Ab) {
  _inherits(Init, _abstractmessage_1$Ab);
  var _super = _createSuper(Init);
  function Init(token, continuationToken, metadata) {
    var _this;
    var registrations = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : null;
    var tweaks = arguments.length > 4 && arguments[4] !== undefined ? arguments[4] : null;
    _classCallCheck(this, Init);
    _this = _super.call(this);
    _this.method = 'init';
    _this.token = token;
    _this.continuation_token = continuationToken;
    _this.metadata = metadata;
    _this.registrations = registrations;
    _this.tweaks = tweaks;
    _this.capabilities = ['client_update', 'offline_storage', 'telemetry.v1'];
    return _this;
  }
  return _createClass(Init);
}(abstractmessage_1.AbstractMessage);
exports.Init = Init;